import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useCurrentUser } from "@/lib/auth";
import { getApiBase } from "@/lib/api";

export default function Login() {
  const { user, isLoading } = useCurrentUser();
  const nav = useNavigate();
  const loc = useLocation();
  // Возвращаем на страницу, с которой выкинуло на логин (AuthGate кладёт её
  // в state.from), а не всегда на дашборд.
  const from = (loc.state as { from?: string } | null)?.from || "/";
  useEffect(() => {
    if (!isLoading && user) nav(from, { replace: true });
  }, [isLoading, user, nav, from]);
  // Pass our origin so the server returns us back here after OAuth (works when
  // the API is on a different domain — tunnel/prod — not just same-origin).
  const loginUrl = `${getApiBase()}/api/auth/regs/login?return=${encodeURIComponent(
    window.location.origin,
  )}`;
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="card p-6 sm:p-8 w-full max-w-[420px] space-y-6">
        <h1 className="text-2xl font-semibold">Вход</h1>
        <a href={loginUrl} className="btn-primary block w-full text-center">
          Войти через Google
        </a>
      </div>
    </div>
  );
}
